import(/* webpackMode: "eager" */ "/app/src/app/auth/register/page.tsx");
